import { COLUMN_TYPES } from 'common/types/summaryDefinitions';
import { generateTotalExpression, getObjectValue } from 'utilities';
import { HandleParentCells } from './types';

const handleParentCells = (params: HandleParentCells): void => {
  const { cell, rowNumber, columnType, companiesGrossIRR } = params;
  const { data } = getObjectValue(cell);
  const { isParent, fundsCount, companyId, parentGrossIRR, parentType } = getObjectValue(data);

  if (isParent && fundsCount) {
    if (parentType === 'fund' && columnType !== COLUMN_TYPES.GROSS_IRR) {
      return;
    }
    const childFundsCount = Array.from({ length: fundsCount }, (_, index) => index + 1); // +1 for 0-based index

    const childFundsExpression = generateTotalExpression({
      generateIndex: false,
      items: childFundsCount,
      skippedIndexes: rowNumber,
    });

    // For Gross IRR column, use the company-level Gross IRR (calculated across all funds)
    if (columnType === COLUMN_TYPES.GROSS_IRR) {
      const companyGrossIRR = companiesGrossIRR && companyId ? companiesGrossIRR[companyId] : null;
      const parentGrossValue = parentGrossIRR ?? (parentType === 'company' ? companyGrossIRR : null);
      Object.assign(cell, {
        expr: '',
        gridType: 'percentage',
        value: parentGrossValue,
      });
    } else {
      Object.assign(cell, {
        expr: `=SUM(${childFundsExpression})`,
      });
    }
  }
};

export default handleParentCells;
